/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';
import { useSessionContext } from '@exo/frontend-common-session-context';
import { parseTokenExpiryTime, useTokenContext } from '@exo/frontend-common-app-identity-and-access';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCartModification } from '../../../../tdcart/tdcart-logic/client/hooks/useCartModification';
import { waitForRequestsToComplete } from '../../../../../../packages/common/apollo/client/links/activeRequests';
import { generateUrlWithLanguage } from '../../../../../utils';

const AUTHENTICATE = gql`
  mutation Auth($username: String!, $password: String!) {
    authLogin(username: $username, password: $password) {
      token
      expiresAt
    }
  }
`;
const TD_AUTHENTICATE = gql`
mutation AuthTDUserLogin($userId: String!, $userLoginType: String!) {
 authTDUserLogin(userID: $userId, userLoginType: $userLoginType) {
   token
   expiresAt
 }
}

`;
export const useAuthentication = () => {
  const session = useSessionContext();
  const cartModfication = useCartModification()
  const tokenContext = useTokenContext()
  const navigate = useNavigate();
  const [authenticate] = useMutation(AUTHENTICATE);
   const [authenticateTD] = useMutation(TD_AUTHENTICATE);

   const logout = useCallback(async () => {
    session.replace({ roles: [], sessionTimeOut: undefined,navigationQ : undefined,cartCount :undefined,language:session.language,configuration: session.configuration,country: session.country,currency : session.currency});
    localStorage.setItem('logout-event', Date.now().toString());
    tokenContext.ensureValidToken();
  }, [session,tokenContext]);

  useEffect(() => {
    const interval = setInterval(() => {
      if ((session?.type === 'USER' || session?.type === "TD_BANK_USER" || session?.type === 'VM_USER') && session?.sessionTimeOut && Date.now() > session?.sessionTimeOut) {
        console.log("SESSION TIMED OUT")
        logout().then(() => {
          navigate(generateUrlWithLanguage('/sessiontimeout', session.language));
          window.location.reload();
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [session, logout, navigate]);

  return {
    authenticate: async (username, password, type = "") => {
      const res = await authenticate({ variables: { username, password } });
      localStorage.setItem('login-event', Date.now().toString());
      session.replace({
        token: res.data.authLogin.token,
        tokenExpiryTime: parseTokenExpiryTime(res.data.authLogin.expiresAt),
        username,
        type: 'USER',
        roles: ['user'],
        isFirstTimeDPMUser: type === 'registration',
        language:session.language,
        country: session.country,
        configuration: session.configuration,
        navigationQ : session.navigationQ
      });
           
      return {
        token: res.data.authLogin.token,
        username
      };
    },
    authenticateTD: async (userId, userLoginType, type = "",lastPage,language) => {
      const username= ""
      console.log("CALLED AUTH::::>",language)
      let TDtoken
      await authenticateTD({ variables: { userId, userLoginType }}).then(async (res) => {
        localStorage.setItem('login-event', Date.now().toString());
        TDtoken = res.data.authTDUserLogin.token;
        session.replace({
          token: res.data.authTDUserLogin.token,
          tokenExpiryTime: parseTokenExpiryTime(res.data.authTDUserLogin.expiresAt),
          username,
          type: 'TD_BANK_USER',
          roles: ['TD_BANK_USER'],
          isFirstTimeDPMUser: type === 'registration',
          sessionTimeOut: parseTokenExpiryTime(res.data.authTDUserLogin.expiresAt),
          language:language,
          country: session.country,
          configuration: session.configuration,
          navigationQ : session.navigationQ
        });

        
        if(lastPage === '/checkout'){
          cartModfication.startCheckout()
          const res  = await cartModfication.mixedCartCheck().then(res => {
            if(res.hasPhysicalProducts && res.hasPooledProducts){
              console.log("inside if")
               navigate("/shop/"+language+"/tdmetals/cart")
            }
            else{
              console.log("inside else")
              navigate("/shop/"+language+"/tdmetals"+lastPage?lastPage : "/")
            }
          }).catch(error => {
              navigate("/shop/"+language+"/tdmetals/cart")
          })
        }
        else{
          console.log("inside else2",language)
            navigate("/shop/"+language+"/tdmetals"+lastPage?lastPage : "/")
        }
      }).catch(error => {
        console.log("Error::::>",error)
      })
      return {
        token: TDtoken,
        userId
      };
    },
    authenticateInterac: async (userId, userLoginType, type = "",lastPage,language) => {
      const username= ""
      console.log("CALLED interac AUTH::::>")
      let TDtoken
      await authenticateTD({ variables: { userId, userLoginType }}).then(async (res) => {
        localStorage.setItem('login-event', Date.now().toString());
        TDtoken = res.data.authTDUserLogin.token;
        console.log("Interac token", TDtoken )
        session.replace({
          token: res.data.authTDUserLogin.token,
          tokenExpiryTime: parseTokenExpiryTime(res.data.authTDUserLogin.expiresAt),
          username,
          type: 'VM_USER',
          roles: ['VM_USER'],
          isFirstTimeDPMUser: type === 'registration',
          sessionTimeOut: parseTokenExpiryTime(res.data.authTDUserLogin.expiresAt),
          language:language,
          country: session.country,
          configuration: session.configuration,
          navigationQ : session.navigationQ
        });

       
        if(lastPage === '/checkout'){
          cartModfication.startCheckout()
          const res  = await cartModfication.mixedCartCheck().then(res => {
            if(res.hasPhysicalProducts && res.hasPooledProducts){
              console.log("inside if")
              navigate("/shop/"+language+"/tdmetals/cart")
            }
            else{
              console.log("inside else")
             navigate("/shop/"+language+"/tdmetals"+lastPage?lastPage : "/")
            }
          }).catch(error => {
            navigate("/shop/"+language+"/tdmetals/cart")
          })
        }
        else{
          console.log("inside else2")
           navigate("/shop/"+language+"/tdmetals"+lastPage?lastPage : "/")
        }
      }).catch(error => {
        console.log("Error::::>",error)
      })
      return {
        token: TDtoken,
        userId
      };
    },
    logout
  };
};
